import React from 'react';

const SummaryCards = () => {
    const cards = [
        {
            title: 'Vencendo',
            value: 3,
            description: 'Vencimentos próximos',
            icon: '🔴',
        },
        {
            title: 'Próximos',
            value: 7,
            description: 'Compromissos próximos',
            icon: '🟡',
        },
        {
            title: 'Programados',
            value: 18,
            description: 'Eventos futuros',
            icon: '🟢',
        },
        {
            title: 'Pendências',
            value: 4,
            description: 'Itens que requerem atenção',
            icon: '⚠️',
        },
    ];

    return (
        <div className="row g-2">
            {cards.map((card) => (
                <div className="col-12 col-sm-6 col-xl-3" key={card.title}> 
                    <div className="card h-100">
                        <div className="card-body">

                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-muted small">
                                        {card.title}
                                    </div>

                                    <div className="fs-3 fw-bold">
                                        {card.value}
                                    </div>
                                </div>

                                <span className="fs-4">
                                    {card.icon}
                                </span>
                            </div>

                            <div className="small text-muted mt-2">
                                {card.description}
                            </div>

                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SummaryCards;
